import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "diary-entry" }
const _hoisted_2 = { class: "entry-icon" }
const _hoisted_3 = {
  width: "16",
  height: "20",
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = ["fill"]
const _hoisted_5 = { class: "diary-entry" }
const _hoisted_6 = { class: "entry-icon" }
const _hoisted_7 = {
  width: "31",
  height: "30",
  viewBox: "0 0 31 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = ["fill"]
const _hoisted_9 = { class: "sleep-chart" }
const _hoisted_10 = {
  viewBox: "0 0 200 80",
  class: "chart-svg"
}
const _hoisted_11 = ["stroke"]

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSettingsStore } from '@/api/store/settings';


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthSuitePanel',
  setup(__props) {

const router = useRouter();
const settingsStore = useSettingsStore();

const buttonColor = computed(() => settingsStore.settings.buttonColor);
const primaryColor = computed(() => settingsStore.settings.primaryColor);
const secondaryColor = computed(() => settingsStore.settings.secondaryColor);

const navigateToHealthSuite = () => {
  router.push('/health-suite');
};

const navigateToHealthTracker = () => {
  router.push('/health-suite/tracker');
};

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "ml-4 mb-4" }, "My Health Suite", -1)),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "pr-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "diary-section clickable-section",
                onClick: navigateToHealthSuite
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "mb-2" }, "My Diary", -1)),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                      _createElementVNode("path", {
                        d: "M3.11328 20V10.85C2.26328 10.6167 1.55078 10.15 0.975781 9.45C0.400781 8.75 0.113281 7.93333 0.113281 7V0H2.11328V7H3.11328V0H5.11328V7H6.11328V0H8.11328V7C8.11328 7.93333 7.82578 8.75 7.25078 9.45C6.67578 10.15 5.96328 10.6167 5.11328 10.85V20H3.11328ZM13.1133 20V12H10.1133V5C10.1133 3.61667 10.6008 2.4375 11.5758 1.4625C12.5508 0.4875 13.7299 0 15.1133 0V20H13.1133Z",
                        fill: buttonColor.value
                      }, null, 8, _hoisted_4)
                    ]))
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "entry-content" }, [
                    _createElementVNode("div", { class: "entry-time" }, "7:00 AM"),
                    _createElementVNode("div", { class: "entry-text" }, "I ate 2 eggs...")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                      _createElementVNode("rect", {
                        x: "0.355469",
                        width: "30",
                        height: "30",
                        rx: "8",
                        fill: primaryColor.value
                      }, null, 8, _hoisted_8),
                      _cache[1] || (_cache[1] = _createElementVNode("rect", {
                        x: "0.355469",
                        width: "30",
                        height: "30",
                        rx: "8",
                        fill: "url(#paint0_linear_0_1)"
                      }, null, -1)),
                      _cache[2] || (_cache[2] = _createElementVNode("path", {
                        d: "M8.19828 22.8153C8.52928 22.8153 8.81891 22.6944 9.06716 22.4528C9.3154 22.2111 9.43953 21.9292 9.43953 21.6069C9.43953 21.2847 9.3154 21.0028 9.06716 20.7611C8.81891 20.5194 8.52928 20.3986 8.19828 20.3986C7.86728 20.3986 7.57766 20.5194 7.32941 20.7611C7.08116 21.0028 6.95703 21.2847 6.95703 21.6069C6.95703 21.9292 7.08116 22.2111 7.32941 22.4528C7.57766 22.6944 7.86728 22.8153 8.19828 22.8153ZM8.19828 16.2097C8.52928 16.2097 8.81891 16.0889 9.06716 15.8472C9.3154 15.6056 9.43953 15.3236 9.43953 15.0014C9.43953 14.6792 9.3154 14.3972 9.06716 14.1556C8.81891 13.9139 8.52928 13.7931 8.19828 13.7931C7.86728 13.7931 7.57766 13.9139 7.32941 14.1556C7.08116 14.3972 6.95703 14.6792 6.95703 15.0014C6.95703 15.3236 7.08116 15.6056 7.32941 15.8472C7.57766 16.0889 7.86728 16.2097 8.19828 16.2097ZM8.19828 9.60417C8.52928 9.60417 8.81891 9.48333 9.06716 9.24167C9.3154 9 9.43953 8.71806 9.43953 8.39583C9.43953 8.07361 9.3154 7.79167 9.06716 7.55C8.81891 7.30833 8.52928 7.1875 8.19828 7.1875C7.86728 7.1875 7.57766 7.30833 7.32941 7.55C7.08116 7.79167 6.95703 8.07361 6.95703 8.39583C6.95703 8.71806 7.08116 9 7.32941 9.24167C7.57766 9.48333 7.86728 9.60417 8.19828 9.60417ZM13.6598 22.8153H23.7553V20.3986H13.6598V22.8153ZM13.6598 16.2097H23.7553V13.7931H13.6598V16.2097ZM13.6598 9.60417H23.7553V7.1875H13.6598V9.60417Z",
                        fill: "white"
                      }, null, -1)),
                      _cache[3] || (_cache[3] = _createElementVNode("defs", null, [
                        _createElementVNode("linearGradient", {
                          id: "paint0_linear_0_1",
                          x1: "15.3555",
                          y1: "0",
                          x2: "15.3555",
                          y2: "30",
                          gradientUnits: "userSpaceOnUse"
                        }, [
                          _createElementVNode("stop", {
                            "stop-color": "white",
                            "stop-opacity": "0.2"
                          }),
                          _createElementVNode("stop", {
                            offset: "1",
                            "stop-color": "white",
                            "stop-opacity": "0"
                          })
                        ])
                      ], -1))
                    ]))
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "entry-content" }, [
                    _createElementVNode("div", { class: "entry-time" }, "9:00 AM"),
                    _createElementVNode("div", { class: "entry-text" }, "Morning Yoga...")
                  ], -1))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "tracker-section clickable-section",
                onClick: navigateToHealthTracker
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "mb-2" }, "My Tracker", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tracker-header" }, [
                  _createElementVNode("span", { class: "tracker-label" }, "Sleep"),
                  _createElementVNode("div", { class: "tracker-nav" })
                ], -1)),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                    _createElementVNode("path", {
                      d: "M10,60 Q30,40 50,45 T90,35 Q110,25 130,30 T170,40 Q185,35 190,30",
                      stroke: secondaryColor.value,
                      "stroke-width": "3",
                      fill: "none"
                    }, null, 8, _hoisted_11)
                  ]))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})